<div class="support-backdrop" *ngIf="showDialog$ | async">
    <div class="support-dialog">
        <div class="support-content">
            <div class="support-header">
                <div class="title-wrap">
                    <div class="title">{{ title }}</div>
                </div>

                <button type="button" class="icon-btn" (click)="close()" aria-label="Close">
                    ✕
                </button>
            </div>

            <div class="support-body">
                <div class="far fa-exclamation-triangle fa-3x"></div>
                {{errorText}}
            </div>

            <div class="support-footer">
                <ng-container *ngIf="{articles: articles$ | async} as footerContext">
                    <div *ngIf="!footerContext.articles" class="spinner-container">
                        <div class="spinner"></div>
                    </div>
                    <button *ngIf="footerContext.articles?.length > 0" type="button" class="btn-primary" (click)="showMoreInformation()">
                        More information
                    </button>
                    <button *ngIf="footerContext.articles?.length === 0" type="button" class="btn-primary" (click)="requestSupport()">
                        Request support
                    </button>
                </ng-container>

                <button type="button" class="btn-ghost" (click)="close()">
                    Close
                </button>
            </div>
        </div>
    </div>
</div>

<al-freshdesk-help-modal #helpModal></al-freshdesk-help-modal>
<app-missing-article-feedback #missingArticleFeedback></app-missing-article-feedback>
